package com.appsyde.shared.modules.account.domain.usecase

import com.appsyde.shared.modules.account.domain.repository.AccountRepository

class UpdateAccountSignatureUseCase(
    private val accountRepository: AccountRepository
) {
    suspend operator fun invoke(signatureEnabled: Boolean, signatureValue: String) {
        accountRepository.updateSignature(signatureEnabled, signatureValue)
    }
}
